import { render, staticRenderFns } from "./ExplanationBlock.vue?vue&type=template&id=271cc2b0"
import script from "./ExplanationBlock.vue?vue&type=script&lang=js"
export * from "./ExplanationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports